import ButtonLink from "../../Navigation/ButtonLink";
import React from "react";
import ToolBar from "../ToolBar";
import { makeStyles } from "@material-ui/core/styles";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme) => ({
  activeButton: {},
  inactiveButton: {
    color: theme.unflashyColor,
    [theme.breakpoints.down("xs")]: {
      "& .MuiButton-label": {
        color: theme.unflashyColor,
      },
    },
  },
}));

const ArticleFilterBar = (props) => {
  const { className, activeCategory, categories, articleGroup } = props;
  const classes = useStyles();
  const { t } = useTranslation("common");
  const pathPrefix = articleGroup === "apps" ? "/apps-digitale-services/" : "/blog/";
  const toplevelCategory = articleGroup === "apps" ? "allapps" : "all";

  return (
    <ToolBar className={`${className ? className : ""}`}>
      {[toplevelCategory].concat(categories).map((category) => (
        <ButtonLink
          key={category}
          as={`${pathPrefix}${category !== "all" ? category : articleGroup === "apps" ? "allapps" : ""}`}
          href={`${pathPrefix}${category !== "all" ? "[...generic]" : articleGroup === "apps" ? "allapps" : ""}`}
          buttonClassName={activeCategory === category ? classes.activeButton : classes.inactiveButton}
          dataTest="article-categories-bar-item"
        >
          {t(`articleCategory_${category.replace("-", "_")}`)}
        </ButtonLink>
      ))}
    </ToolBar>
  );
};

export default ArticleFilterBar;
